import {useEffect} from "react";
import isEmpty from "is-empty";

export default function useShowWheelOfFortune(props) {
    const {mobileApp = false, stores = {}, config = {}} = props;
    const {modalStore = {}} = stores;
    const {saleTypes = {}} = config;
    const {wheelOfFortune = {}} = saleTypes;

    useEffect(() => {
        /**
         * Проходим далее если:
         * 1. На сайт попадают не из приложений
         * 2. Дата не null
         * 3. Текущая дата меньше установленной
         * 4. Окно показывается в первые
         */
        if (mobileApp || wheelOfFortune.endDate === null || new Date() > new Date(wheelOfFortune.endDate) || !isEmpty(localStorage.getItem('wheelOfFortune'))) {
            return;
        }

        // Показываем окно с задержкой в 3 секунды
        setTimeout(() => {
            modalStore.openWheelOfFortuneModal();
        }, 3000)
    }, []);
}
